import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { NotificationDto } from "../../store/header/header.models";

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {

    getNotifications(): Observable<NotificationDto[]> {
        const sortedNotifications = fakeNotifications.sort((a, b) => {
            if (a.isRead !== b.isRead) {
                return a.isRead ? 1 : -1;
            }

            const aTime = a.timestamp ? a.timestamp.getTime() : -Infinity;
            const bTime = b.timestamp ? b.timestamp.getTime() : -Infinity;

            return bTime - aTime;
        });
        return of(sortedNotifications);
    }
}

const fakeNotifications: NotificationDto[] = [
    {
        id: '1',
        displayText: 'Notification 1',
        isRead: true,
        timestamp: new Date(2025, 6, 3, 10, 20)
    },
    {
        id: '2',
        displayText: 'Notification 2',
        isRead: false,
        timestamp: new Date(2025, 6, 3, 10, 25)
    },
    {
        id: '3',
        displayText: 'Notification 3',
        isRead: false,
        timestamp: new Date(2025, 6, 3, 10, 26)
    },
]